import { ReactElement } from 'react';
import { useRouter } from 'next/router';
import { ProductJsonLd } from 'next-seo';
import { Variant } from 'lib/bigcomm/client';
import { IProductVariantFields } from 'types/contentful';

interface ProductData {
  productName: string;
  description: string;
  variantContent: IProductVariantFields;
  variant: Variant;
  brand: string;
  material: string;
  color: string;
  siteName: string;
}

export default function ProductData({
  productName,
  description,
  variant,
  variantContent,
  brand,
  material,
  color,
  siteName,
}: ProductData): ReactElement {
  const { asPath } = useRouter();
  const images: string[] = [
    variantContent.primaryFrameImage?.fields.file.url as string,
    ...(variantContent.alternateFrameImages?.map((image) => image.fields.file.url) || []),
  ];

  return (
    <ProductJsonLd
      productName={productName}
      images={images}
      description={description}
      brand={brand}
      color={color}
      material={material}
      sku={variant.sku}
      offers={{
        price: variant.price.toString(),
        priceCurrency: 'USD',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
        url: asPath,
        seller: {
          name: siteName,
        },
      }}
    />
  );
}
